import { Input, Modal } from 'antd';
import { ModalTitle } from '~components/_common/ModalTitle/ModalTitle';
import { useIntl } from 'react-intl';
import { Fragment, useRef, useState } from 'react';

const initialFormValues = {
  name: '',
  description: '',
};

export const ContractBuilderAddGroupModal = ({
  visible,
  onCancel,
  onOk,
  confirmLoading,
}) => {
  const intl = useIntl();

  const [formValues, setFormValues] = useState(initialFormValues);
  const nameInputRef = useRef<Input>(null);

  const isValid = () => {
    if (!formValues.name) return false;

    return true;
  };

  const handleSubmit = () => {
    onOk(formValues);
  };

  return (
    <Modal
      title={
        <ModalTitle
          text={intl.formatMessage({ id: 'add-group' })}
          icon={['far', 'ticket']}
        />
      }
      okText={intl.formatMessage({ id: 'add' })}
      cancelText={intl.formatMessage({ id: 'cancel' })}
      width={425}
      centered
      visible={visible}
      onOk={handleSubmit}
      confirmLoading={confirmLoading}
      okButtonProps={{ disabled: !isValid() }}
      onCancel={onCancel}
      destroyOnClose
      afterClose={() => setFormValues(initialFormValues)}>
      <Fragment>
        <Input
          ref={nameInputRef}
          placeholder={intl.formatMessage({ id: 'name' })}
          allowClear
          value={formValues.name}
          onChange={(e) =>
            setFormValues({ ...formValues, name: e.target.value })
          }
          onPressEnter={() => {
            if (isValid()) {
              handleSubmit();
            }
          }}
        />
      </Fragment>
    </Modal>
  );
};
